import "./pd-mail/pd-mail-item.js";
import { PdMailList } from "./pd-mail/PdMailList.js";
//#region src/pd-mail/pd-mail-list.ts
var tag = "pd-mail-list";
if (!customElements.get(tag)) customElements.define(tag, PdMailList);
//#endregion
export { PdMailList };
